// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + (chunkId === "588" ? "schema-dsl-compiler-wasm" : chunkId) + "." + {"588": "8e50d8e2","673": "f31a85af","947": "106885b9",}[chunkId] + ".js"
}